var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBxInfoCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bx-info-circle.svg"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15 2.5C8.1075 2.5 2.5 8.1075 2.5 15C2.5 21.8925 8.1075 27.5 15 27.5C21.8925 27.5 27.5 21.8925 27.5 15C27.5 8.1075 21.8925 2.5 15 2.5ZM15 25C9.48625 25 5 20.5138 5 15C5 9.48625 9.48625 5 15 5C20.5138 5 25 9.48625 25 15C25 20.5138 20.5138 25 15 25Z",
    fill: "#0A30CE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.25 16.25L13.75 16.25L13.75 8.75L16.25 8.75L16.25 16.25ZM16.25 21.25L13.75 21.25L13.75 18.75L16.25 18.75L16.25 21.25Z",
    fill: "#0A30CE"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxInfoCircle);
export default __webpack_public_path__ + "static/media/bx-info-circle.9b27bc45eb21fc9cf919a702b9b1d0f5.svg";
export { ForwardRef as ReactComponent };